import React from "react"
import PropTypes from "prop-types"

import BookingUpdate from "./BookingUpdate"
import { reverse } from "utils/urls"

export default function AirlineBookingUpdate(props) {
  return (
    <BookingUpdate
      isAirline
      detailEndpoint={`/bookings/airline-bookings/${props.match.params.id}/?edit=true`}
      listRoute={reverse("airlineBookingList")}
      successUrl={reverse("airlineBookingDetail", {
        id: props.match.params.id,
      })}
    />
  )
}

AirlineBookingUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
